import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  IncomeDeclare: (param) => {   // 个税申报
    return GET("/backend/taxDetail/querySeasonTax", param);
    // return GET("/backend/taxDetail/queryTaxDetailByPage", param);
  },
  exportTaxExcel: (param, rsType) => { // 个税申报-季度列表导出
    return GETPDF("/backend/taxDetail/exportTaxExcel", param, rsType);
  },
  checkTaxDetail: (param) => { // 个税申报 确认申报
    return POST("/backend/taxDetail/checkTaxDetail", param);
  },
  DeclareHistory: (param) => {   // 申报历史
    return GET("/backend/taxBillRecord/queryTaxBillByPage", param);
  },
  DeclareHistoryExport: (param, rsType) => {   // 申报历史 导出
    return GETPDF("/backend/taxBillRecord/queryTaxBillByExport", param, rsType);
  },
  NewlyTaxBill: (param) => {   // 申报历史-新增税单
    return POST("/backend/taxBillRecord/save", param);
  },
  DeleteTaxBill: (param) => {   // 申报历史-删除税单
    return GET("/backend/taxBillRecord/delete", param);
  },
  DrawbackRecord: (param) => {   // 退款记录
    return GET("/backend/accountRefund/queryAccountRefundBypage", param);
  },
  DerivedRecordExport: (param, rsType) => {   // 退款记录导出
    return GETPDF("/backend/accountRefund/queryAccountRefundExport", param, rsType);
  },
  HandleRecord: (param) => {   // 退款记录审核
    return POST("/backend/accountRefund/updateRefundStatus", param);
  },

  // 退款管理 --退款申请


  getRefundNeedInfo: (param) => {   // 获取退款所需的账户信息
    return GET("/backend/accountRefund/getRefundNeedInfo", param);
  },

  calculateServiceFee: (param) => {   // 计算退款的服务费
    return POST("/backend/accountRefund/calculateServiceFee", param);
  },

  createRefundOrder: (param) => {   // 创建退款订单接口/退款申请
    return POST("/backend/accountRefund/createRefundOrder", param);
  },

  // 退款管理 --退款审核

  checkRefundList: (param) => {   // 退款审核列表
    return GET("/backend/accountRefund/getNeedCheckRefundList", param);
  },
  checkRefundOrder: (param) => {   // 退款审核
    return POST("/backend/accountRefund/checkRefundOrder", param);
  },

  // 退款管理 --退款记录列表
  getCheckedRefundList: (param) => {   // 退款记录列表
    return GET("/backend/accountRefund/getCheckedRefundList", param);
  },
  // 退款管理 --退款记录列表导出
  getCheckedRefundListExport: (param) => {   // 退款记录列表导出
    return GET("/backend/accountRefund/getCheckedRefundExport", param);
  },
  // 退款管理 --退款记录上传文件
  updateRefundFile: (param) => {   // 退款记录上传文件
    return POST("/backend/accountRefund/updateRefundFile", param);
  },
  // 退款管理 --删除退款凭证
  deleteRefundFile: (param) => {   // 删除退款凭证
    return POST("/backend/accountRefund/deleteRefundFile", param);
  },
  // 退款管理 --重新退款接口
  retryRefund: (param) => {   // 重新退还接口
    return POST("/backend/accountRefund/retryRefund", param);
  },

  // 个税计算器
  calTax: (param) => {
    return POST("/backend/taxDetail/calTax/" + param.type + "/" + param.exemptionSwitch, param.list);
  },
  // 个税统计列表
  taxCensusList: (param) => {   // 个税统计列表
    return GET("/backend/taxDetail/taxCensusList", param);
  },
  // 个税统计列表导出
  taxCensusListExport: (param) => {   // 个税统计列表导出
    return GET("/backend/taxDetail/taxCensusListExport", param);
  },
  // 个税统计查看详情
  taxCensusDetails: (param) => {   // 个税统计查看详情
    return GET("/backend/taxDetail/taxCensusDetails", param);
  },
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/refundAdmin.js